"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvoidIsPhone = void 0;
const react_1 = __importDefault(require("react"));
/* WARNING
We should be using it as little as possible since it doesn't work on the server
and then guarantees layout shift.
*/
const useAvoidIsPhone = () => {
    const [isPhone, isPhoneSet] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        // Since we aren't passing this from the server, we need to set it
        // after mount so the server/client diff matches
        if (/android/i.test(navigator.userAgent) ||
            /iPhone|iPod/.test(navigator.userAgent)) {
            isPhoneSet(true);
        }
    }, []);
    return isPhone;
};
exports.useAvoidIsPhone = useAvoidIsPhone;
//# sourceMappingURL=useAvoidIsPhone.js.map